export const GlobalOptionsLoader = {
  backgroundColor: "rgba(33, 33, 69, 0.2)"
}